import styled from 'styled-components';
import { PANEL_CONTENT_TYPE } from '../../enums';
import { PicturePanel, PicturePanelProps } from '../picturePanel';
import React from 'react';
import { VideoPanel, VideoPanelProps } from '../videoPanel';
import {
  RichTextPanel,
  RichTextProps,
} from '../contentfulSpecificComponents/richTextPanel';
import { HtmlEmbedPanel, HtmlPanelProps } from '../htmlEmbed';
import { breakpoints, theme } from '../../theme';

// Styled-component-breakpoint breakpoint function does not work under the context of prop variable i.e. itemCount
export const GridContainer = styled.div<{ itemCount: number }>`
  display: grid;

  ${({ itemCount }) => `
    @media (min-width: ${breakpoints.xs}px) and (max-width: ${
    breakpoints.sm - 1
  }px) {
        grid-template-columns: repeat(1, 1fr);
        grid-gap: ${theme.spacings[4].px};
    }

    @media (min-width: ${breakpoints.sm}px) and (max-width: ${
    breakpoints.md - 1
  }px) {
        grid-template-columns: repeat(${itemCount}, 1fr);
        grid-gap: ${theme.spacings[4].px};
    }

    @media (min-width: ${breakpoints.md}px) {
        grid-template-columns: repeat(${itemCount}, 1fr);
        grid-gap: ${
          itemCount > 3 ? theme.spacings[5].px : theme.spacings[6].px
        };
    }
  `}
`;

export const GridItem = styled.div`
  overflow-y: auto;
`;

export type ColumnPanelProps = {
  columnPanelsCollection: {
    items: any[];
  };
};

const renderPanel = (item: any) => {
  item.padding = false; // Disable component level padding when using Column Panel
  switch (item.__typename) {
    case PANEL_CONTENT_TYPE.PICTURE_PANEL:
      return <PicturePanel {...(item as PicturePanelProps)} />;
    case PANEL_CONTENT_TYPE.VIDEO_PANEL:
      return <VideoPanel {...(item as VideoPanelProps)} />;
    case PANEL_CONTENT_TYPE.RICH_TEXT_PANEL:
      return <RichTextPanel {...(item as RichTextProps)} />;
    case PANEL_CONTENT_TYPE.HTML_EMBED:
      return <HtmlEmbedPanel {...(item as HtmlPanelProps)} />;
    default:
      return null;
  }
};
export const ColumnPanel: React.FC<ColumnPanelProps> = (data) => {
  return (
    <GridContainer itemCount={data?.columnPanelsCollection?.items?.length}>
      {data?.columnPanelsCollection?.items?.map((item, index) => {
        return <GridItem key={index}>{renderPanel(item)}</GridItem>;
      })}
    </GridContainer>
  );
};
